import './services.image';
app.directive('variationSelector', [
  '$filter',
  'userAgentService',
  'imageService',
  '$timeout',
  '$window',
  function ($filter, userAgentService, imageService, $timeout, $window) {
    return {
      restrict: 'E',
      scope: {
        model: '=',
        items: '=',
        quickCart: '=',
        product: '=',
        index: '@',
        onChange: '&',
        variantId: '@',
        containerClass: '@?',
      },
      templateUrl: require('../../../../../public/themes/v1/default/views/product.variation-selector.html'),
      link: function (scope, element) {
        const visibleRow = 3;
        const elementClass = scope.containerClass
          ? element.closest(scope.containerClass)[0]
          : element.find('.Variation-container')[0];
        let elementWidth, elementsPerRow;

        // Function to recalculate elementsPerRow based on actual .Variation-wrap width
        function recalculateElementsPerRow() {
          const variationWrap = element
            .find('.Variation-wrap')
            .filter(function () {
              return $(this).outerWidth(true) > 0;
            })
            .first();

          if (!variationWrap.length) return;

          const variationWrapWidth = variationWrap.outerWidth(true);
          elementWidth = elementClass.getBoundingClientRect().width;
          elementsPerRow = Math.floor(elementWidth / variationWrapWidth) || 1;
          const showMoreLimitCount = elementsPerRow * 2 - 1;
          // Update dependent values
          scope.numberOfElementInVisibleRow = elementsPerRow * visibleRow;
          scope.displayShowMoreButton =
            scope.options.length > elementsPerRow * 2;
          scope.showMore =
            scope.nameArray.indexOf(scope.model[scope.index]) >
            showMoreLimitCount;
        }

        const observer = new MutationObserver(recalculateElementsPerRow);
        observer.observe(elementClass, {
          childList: true,
          subtree: true,
        });

        // Recalculate when resizing
        const onResize = _.debounce(() => {
          $timeout(recalculateElementsPerRow, 0);
        }, 100);
        $window.addEventListener('resize', onResize);

        // Cleanup
        scope.$on('$destroy', () => {
          $window.removeEventListener('resize', onResize);
          onResize.cancel?.();
          observer.disconnect();
        });

        if (scope.variantId) {
          var selectedVariation = scope.product.variations.find(
            function (variation) {
              return variation.key === scope.variantId;
            },
          );
          $filter('translateModel')(
            selectedVariation.fields_translations,
          ).forEach(function (optionName, index) {
            scope.model[index] = optionName;
          });
          scope.onChange();
          if (!userAgentService.isMobi()) {
            $timeout(function () {
              $('.Variation-wrap').tooltip('hide');
            });
          }
        }

        scope.toggleShowMore = function () {
          scope.showMore = !scope.showMore;
        };

        var setOptionNames = function () {
          scope.nameArray = _.map(scope.options, function (item) {
            return $filter('translateModel')(item.name_translations);
          });
        };

        var setOptions = function () {
          scope.options = scope.product.digest_variations[scope.index].map(
            function (variation) {
              return _.find(scope.product.variant_options, function (option) {
                return (
                  $filter('translateModel')(option.name_translations) ===
                  variation
                );
              });
            },
          );
        };

        // Fallback for when .Variation-wrap is rendered before MutationObserver is ready.
        scope.$watch('options', function (newVal) {
          if (newVal?.length) $timeout(recalculateElementsPerRow, 0);
        });

        scope.$watch(
          'product.digest_variations',
          function () {
            setOptions();
            setOptionNames();
          },
          true,
        );

        scope.selectVariation = function (selectedIndex) {
          scope.model[scope.index] = scope.nameArray[selectedIndex];
          scope.onChange();
          if (!userAgentService.isMobi()) {
            $timeout(function () {
              $('.Variation-wrap').tooltip('hide');
            });
          }
        };

        scope.getVariantImageUrl = (media) => {
          return imageService.getMediaImageUrl(media, { size: '60x60' });
        };

        if (userAgentService.isMobi()) {
          $('.Variation-wrap').tooltip('disable');
        } else {
          $timeout(function () {
            $('.Variation-wrap').tooltip();
          });
        }
      },
    };
  },
]);
